export const modalTableConfig = {
  title: '资源明细',
  propList: [
    {
      prop: 'uname',
      label: '客户昵称',
      minWidth: '120',
      fixed: true
    },
    { prop: 'uid', label: '客户ID', minWidth: '180' },
    {
      prop: 'unionid',
      label: 'unionID',
      minWidth: '200'
    },
    {
      prop: 'corpName',
      label: '主体名称',
      minWidth: '120'
    },
    {
      prop: 'sid',
      label: '所属账号',
      minWidth: '120'
    },
    {
      prop: 'sname',
      label: '账号名称',
      minWidth: '120',
    },
    {
      prop: 'lastUsedBy',
      label: '使用人',
      minWidth: '120'
    },
    {
      prop: 'groupName',
      label: '所属组',
      minWidth: '120'
    },
    {
      prop: 'createdAt',
      label: '打入时间',
      minWidth: '220'
    },
    {
      prop: 'deletedAt',
      label: '删除时间',
      minWidth: '220'
    }
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
